//
// ChatMessage - Component for displaying basic text chat messages
// Shows user messages with author information, timestamps, and basic controls
//

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { memo } from 'react';

import {
  Column,
  Row,
} from '../../../display';

import ChatMessageControls from './ChatMessageControls';
import {
  ChatAuthorIcon,
  ChatAuthorName,
  ChatDate,
  ChatItemClick,
  MessageFrame,
  MessageText,
} from './components';

const ChatMessage = memo(({
  registerChild,
  translate,
  style,
  message,
  author,
  initials,
  crBlocked,
  color,
  gcatCode,
  grpGpid,
  grpLbl,
  grpNbr,
  visibleInThisGathering = true,
  // isScrolling,
  // isVisible,
  groupsMap,
  imagesMap,
  selectGathering,
  prtnrLogoUrl,
}) => {
  // const [showControls, setShowControls] = useState(false);
  const {
    id,
    msgTxt,
    msgRdatim1,
    gthrId,
  } = message;

  return (
    <div
      ref={registerChild}
      key={id}
      className={classNames(
        'w-full py-2 gap-1 flex flex-col relative items-center justify-center overflow-hidden group',
        {
          'px-6': visibleInThisGathering,
          'px-2 opacity-50': !visibleInThisGathering,
        },
      )}
      style={style}
      // https://stackoverflow.com/a/61613591/9316077
      // onMouseEnter={() => { setShowControls(true); }}
      // onMouseLeave={() => { setShowControls(false); }}
    >
      <ChatItemClick
        gthrId={gthrId}
        selectGathering={selectGathering}
        visibleInThisGathering={visibleInThisGathering}
      />

      <ChatAuthorName
        translate={translate}
        author={author}
        initials={initials}
        crBlocked={crBlocked}
        gcatCode={gcatCode}
        grpNbr={grpNbr}
        prtnrLogoUrl={prtnrLogoUrl}
      />

      <Row
        start={!!author}
        end={!author}
        fullw
      >
        <ChatAuthorIcon
          author={author}
          initials={initials}
          color={color}
          gcatCode={gcatCode}
          grpGpid={grpGpid}
          grpLbl={grpLbl}
          groupsMap={groupsMap}
          imagesMap={imagesMap}
        />

        <MessageFrame
          key={id}
          author={author}
          visibleInThisGathering={visibleInThisGathering}
        >
          <MessageText
            message={msgTxt}
            author={author}
          />
        </MessageFrame>

        <Column
          className={classNames(
            'self-start',
            {
              'order-2': !author,
              'order-4': author,
            },
          )}
          gap={1}
          crossStart={author}
          crossEnd={!author}
        >
          <ChatDate
            dtime={msgRdatim1}
            myMessage={!author}
          />

          <ChatMessageControls
            translate={translate}
            message={message}
            author={author}
          />
        </Column>

      </Row>
    </div>
  );
});
ChatMessage.displayName = 'ChatMessage';

ChatMessage.propTypes = {
  registerChild: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  style: PropTypes.shape({}).isRequired,
  author: PropTypes.string,
  initials: PropTypes.string,
  crBlocked: PropTypes.number,
  color: PropTypes.string,
  gcatCode: PropTypes.string,
  grpGpid: PropTypes.string,
  grpLbl: PropTypes.string,
  grpNbr: PropTypes.number,
  visibleInThisGathering: PropTypes.bool,
  // isScrolling: PropTypes.bool.isRequired,
  // isVisible: PropTypes.bool.isRequired,
  groupsMap: PropTypes.instanceOf(Map).isRequired,
  imagesMap: PropTypes.instanceOf(Map).isRequired,
  selectGathering: PropTypes.func,
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    msgTxt: PropTypes.string.isRequired,
    msgRdatim1: PropTypes.string.isRequired,
    gthrId: PropTypes.number,
  }).isRequired,
  prtnrLogoUrl: PropTypes.string,
};

export default ChatMessage;
